import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { SplitButton } from 'primereact/splitbutton'
import {
  Badge,
  Btn,
  ConfirmDialog,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  ImportExcelFile,
  InputNumeroInteiro,
  InputText,
  PageHeader,
  ThreeDots,
} from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import useCadastroPosicoesEstoqueHook, {
  IMPORT_OPTIONS,
  LOAD_MESSAGE,
  MENU_ITEMS,
} from './CadastroPosicoesEstoqueHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import ModalCadastroPosicaoEstoque from './ModalCadastroPosicaoEstoque'
import * as colors from '../../../../../assets/js/colors'
import { FaTrash } from 'react-icons/fa'
import { Fieldset } from 'primereact/fieldset'

function CadastroPosicoesEstoque({ selectedTp, history, dispatch }) {
  const { state, localDispatch } = useCadastroPosicoesEstoqueHook()
  const [globalFilter, setGlobalFilter] = useState('')

  const { selectedEstoque } = history.location.state

  useEffect(() => {
    if (selectedTp !== selectedEstoque.tp_id) history.goBack()
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoque(selectedTp, selectedEstoque.id)
        break

      case LOAD_MESSAGE.CREATE_POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      case LOAD_MESSAGE.UPDATE_POSICOES_EXCEL:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.excluirPosicao(state.selectedPosicao.id, selectedTp)
        break

      case LOAD_MESSAGE.DELETE_MULTIPLES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteMultiplesPosicoes(
          selectedTp,
          state.posicoes.filter(p => p.selected),
        )
        break

      case LOAD_MESSAGE.UPDATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.updatePosicoesEstoque(selectedTp, state.posicoesToUpdate)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  return (
    <>
      <PageHeader>8.1.2 - Posições do Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          showBtnNovo={selectedTp}
          onVoltar={history.goBack}
        >
          <div className="p-grid">
            <div className="p-col-12">
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={localDispatch.onSelecionarTodosChange}
              >
                Selecionar Todos
              </CustomCheckbox>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <SplitButton
                  style={{ height: '35px' }}
                  menuStyle={{ width: 300 }}
                  className="bck-primary"
                  label={"Gerar os TAG's Posições"}
                  onClick={() => localDispatch.onBtnGerarTagAreaClick(selectedTp, state.posicoes)}
                  model={[
                    {
                      label: "Gerar os TAG's Posições - Horizontal",
                      command: () =>
                        localDispatch.onBtnGerarTagAreaHorizontalClick(selectedTp, state.posicoes),
                    },
                    {
                      label: "Gerar os TAG's Posições - Full Horizontal",
                      command: () =>
                        localDispatch.onBtnGerarTagAreaFullHorizontalClick(selectedTp, state.posicoes),
                    }
                  ]}
                />
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <Btn
                  onClick={() =>
                    localDispatch.onClickSalvarSequencias(state.posicoes, state.originalPosicoes)
                  }
                >
                  Salvar Sequencias
                </Btn>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <Btn
                  onClick={() =>
                    localDispatch.onClickDeletarPosicoes(state.posicoes.filter(p => p.selected))
                  }
                >
                  Deletar Posições
                </Btn>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <SplitButton
                  style={{ height: '35px' }}
                  menuStyle={{ width: 250 }}
                  className="bck-primary"
                  label="01 . Exportar"
                  onClick={() =>
                    localDispatch.onBtnExportarClick(
                      state.posicoes.filter(f => f.selected),
                      selectedTp
                    )
                  }
                  model={[
                    {
                      label: '02. Modelo de Posições',
                      command: () =>
                        localDispatch.onBtnExportarExcel(),
                    }
                  ]}
                ></SplitButton>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <ImportExcelFile
                  label="01. Importar Modelo de Posições"
                  classes="bck-primary"
                  hasIcon={true}
                  menuStyle={{ width: 300 }}
                  defaultOptionKey={IMPORT_OPTIONS.MODELO}
                  model={[
                    {
                      label: '02. Importar Edições de Posições',
                      key: IMPORT_OPTIONS.EDICOES,
                    },
                  ]}
                  onFileImported={(content, option) =>
                    option === IMPORT_OPTIONS.EDICOES
                      ? localDispatch.onBtnImportarEdicoesClick(
                          content,
                          selectedEstoque,
                          selectedTp,
                        )
                      : localDispatch.onBtnImportarClick(content, selectedEstoque, selectedTp)
                  }
                />
              </div>
            </div>

            <div className="p-col-12">
              <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12">
                <div className="p-grid p-align-center">
                  <div className="p-col-4">
                    <InputText
                      label="Endereço"
                      value={state.filtroEndereco}
                      placeholder="Digite parte do endereço"
                      onChange={v => localDispatch.onFiltroChange('filtroEndereco', v)}
                      onEnter={localDispatch.onBuscarFiltrado}
                    />
                  </div>
                  <div className="p-col-2" style={{ marginTop: 32 }}>
                    <Btn onClick={localDispatch.onBuscarFiltrado}>Filtrar</Btn>
                  </div>
                </div>
              </Fieldset>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.posicoes}
                emptyMessage="Não existe posição cadastrada"
                loading={state.isLoading}
                rows={10}
                paginator={true}
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                globalFilter={globalFilter}
              >
                <Column
                  header="#"
                  style={tableCellCentered(80)}
                  body={item => (
                    <CustomCheckbox
                      checked={item.selected === true}
                      onChange={() => localDispatch.onItemCheckboxClick(item)}
                    />
                  )}
                />
                <Column sortable field="id" header="Código" style={tableCellCentered(120)} />
                <Column sortable field="endereco" header="Endereço" />
                <Column
                  sortable
                  field="sequencia"
                  style={tableCellCentered(120)}
                  body={posicao => (
                    <InputNumeroInteiro
                      marginTop={0}
                      value={posicao.sequencia}
                      onChange={value => localDispatch.onChangePosicao(posicao, value)}
                    />
                  )}
                  header="Sequencia"
                />
                <Column field="capacidade" style={tableCellCentered(120)} header="Capacidade" />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={posicao => (
                    <ThreeDots
                      items={MENU_ITEMS}
                      onClick={item => localDispatch.onMenuItemClicked(item, posicao, selectedTp)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
                {localDispatch.verifyMenuItemAllowed({ id: 35, content: '2. Apagar' }) && (
                  <Column
                    header=""
                    style={tableCellCentered(70)}
                    body={pick => (
                      <FaTrash
                        style={{ cursor: 'pointer' }}
                        color="red"
                        onClick={() =>
                          localDispatch.onMenuItemClicked('2. Apagar', pick, selectedTp)
                        }
                      />
                    )}
                    bodyStyle={tableCellCentered()}
                  />
                )}
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalCadastroPosicaoEstoque
        data={state.modal.data}
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        estoqueId={selectedEstoque.id}
        selectedTp={selectedTp}
        sequenciaBegin={localDispatch.getLastSequence(state.posicoes)}
      />
      <ConfirmDialog
        isVisible={state.modalConfirmDelete.show}
        title="Atenção"
        content={<span>Tem certeza que deseja excluir a posição de estoque?</span>}
        onCancelar={localDispatch.onModalDeleteClose}
        onOk={() => localDispatch.onModalDeleteSave(state.modalConfirmDelete.data)}
      />
    </>
  )
}

export function BadgeOcupationPosition({ caixas }) {
  if (caixas) return <Badge color={colors.vermelho_hover}>Ocupado</Badge>
  else return <Badge color={colors.verde_hover}>Vazio</Badge>
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroPosicoesEstoque))
